import * as React from "react";
const Ssl = props => <symbol viewBox="0 0 24 24" {...props}>
    <g>
      <path d="M7 6.25a.75.75 0 000 1.5h8a.75.75 0 100-1.5z" />
      <path d="M10 20.25H5A1.251 1.251 0 013.75 19V5A1.251 1.251 0 015 3.75h12A1.251 1.251 0 0118.25 5v4a.75.75 0 101.5 0V5A2.752 2.752 0 0017 2.25H5A2.753 2.753 0 002.25 5v14A2.753 2.753 0 005 21.75h5a.75.75 0 100-1.5z" />
      <path d="M21.332 13.327l-4.05-2a.822.822 0 00-.664 0l-4.05 2c-.234.152-.418.378-.418.673v2.95a4.8 4.8 0 109.6 0V14c0-.286-.176-.535-.418-.673zM16.95 20.25a3.304 3.304 0 01-3.3-3.3v-2.484l3.3-1.63 3.3 1.63v2.484a3.304 3.304 0 01-3.3 3.3zM11 9.25H7a.75.75 0 000 1.5h4a.75.75 0 100-1.5z" />
    </g>
  </symbol>;
export default Ssl;